import { createStyles } from '@mantine/core';

export const useSideBarStyle = createStyles((theme) => ({
  mainWrapper: {
    // left: 0,
    // top: 0,
    inset: 0,
    position: 'absolute',
    height: '72svh',
    backgroundColor: theme.colors.yellow[theme.fn.primaryShade()],
    borderRadius: '0 0 250px 0',
    zIndex: -1,
  },

  cornerWrapper: {
    right: 0,
    top: 0,
    position: 'absolute',
    height: '150px',
    backgroundColor: theme.colors.yellow[theme.fn.primaryShade()],
    borderRadius: '0 0 250px 0',
    zIndex: -1,
    transform: 'matrix(-1, 0, 0, 1, 0, 0)',
  },

  cornerSideWrapper: {
    right: 0,
    top: 0,
    position: 'fixed',
    height: '367px',
    backgroundColor: theme.colors.yellow[theme.fn.primaryShade()],
    borderRadius: '0 0 250px 0',
    zIndex: -1,
    transform: 'matrix(-1, 0, 0, 1, 0, 0)',
  },
}));
